import {
    fetchProjects as _fetchProjects,
    fetchProject as _fetchProject,
    updateProject as _updateProject
} from "../../../utils/api";

export const fetchProject = (projectId) => {
    return _fetchProject(projectId);
}

export const fetchProjects = (projectId) => {
    return _fetchProjects(projectId);
}

export const updateProject = (projectId, payload) => {
    return _updateProject(projectId, payload);
}